// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colors */
  --primary-main: #02d38d;
  --primary-light: #33dc9f;
  --primary-dark: #019362;
  --primary-alpha-10: rgba(2, 211, 141, 0.1);
  
  --secondary-main: #000000;
  --secondary-light: #333333;
  --secondary-dark: #000000;
  
  /* Neutral colors */
  --gray-25: #fcfcfd;
  --gray-50: #f9fafb;
  --gray-100: #f2f4f7;
  --gray-200: #eaecf0;
  --gray-300: #d0d5dd;
  --gray-400: #98a2b3;
  --gray-500: #667085;
  --gray-600: #475467;
  --gray-700: #344054;
  --gray-800: #1d2939;
  --gray-900: #101828;
  
  /* Status colors */
  --error: #f04438;
  --error-light: #fee4e2;
  --success: var(--primary-main);
  --success-light: var(--primary-alpha-10);
  --warning: #f79009;
  --warning-light: #fef0c7;
  
  /* Backgrounds */
  --bg-white: #ffffff;
  --bg-default: var(--gray-100);
  --bg-paper: var(--bg-white);
  --bg-subtle: var(--gray-50);
  
  /* Shadows */
  --shadow-xs: 0px 1px 2px rgba(16, 24, 40, 0.05);
  --shadow-sm: 0px 1px 3px rgba(16, 24, 40, 0.1);
  --shadow-md: 0px 5px 22px rgba(0, 0, 0, 0.04), 0px 0px 0px 1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0px 8px 28px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.06);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--gray-100);
  color: var(--gray-900);
  line-height: 1.5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Custom scrollbar styles */
html body ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

html body ::-webkit-scrollbar-track {
  background: var(--gray-100);
}

html body ::-webkit-scrollbar-thumb {
  background: var(--gray-300);
  border-radius: 4px;
}

html body ::-webkit-scrollbar-thumb:hover {
  background: var(--gray-400);
}

/* Table styles with React Admin component hierarchy */


.RaDatagrid-table .RaDatagrid-row .RaDatagrid-headerCell {
  background-color: var(--gray-50);
  color: var(--gray-500);
  white-space: nowrap;
  line-height: 2;
}
.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall {
  color: var(--gray-800);
  width: 30px;
  overflow: hidden;
  display: inline-block;
  height: 30px;
  text-align: right;
  min-width: 30px;
  padding: 0;
}

.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall:hover {
  background-color: var(--gray-100);
}
.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall .MuiButton-icon {
  margin: 0;
}
.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall .MuiButton-icon svg {
  font-size: 22px;
}
@media (min-width: 600px) {
  .RaList-actions .css-18hcsan-RaFilterForm-root {
      min-height: auto;
      margin: 0;
      padding: 0;
  }
}
.css-1ycqwd-RaList-root .RaList-main {
  background-color: var(--bg-paper);
  color: var(--gray-900);
  background-image: none;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  border-radius: 20px;
  box-shadow: var(--shadow-md);
}
.MuiBox-root.css-106q77t{
  background: var(--bg-white);
}
.RaCreate-main .MuiPaper-root.MuiPaper-elevation, 
.RaEdit-main .MuiPaper-root.MuiPaper-elevation {
  padding: 50px 32px 32px;
}
.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiStack-root, 
.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiStack-root {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px 40px;
  margin-bottom: 32px;
  padding: 0;
}
.css-17418m4-RaEdit-root .RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiStack-root{
  display: block;
}
.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root, 
.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root {
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputLabel-root, 
.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputLabel-root {
  color: var(--gray-700);
  transform: none;
  top: -30px;
  font-weight: 500;
}
.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input, 
.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input {
  height: auto;
  padding: 12px 20px;
  font-size: 0.875rem;
  color: var(--gray-900);
  line-height: 1.5;
}

.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root.Mui-focused, 
.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root.Mui-focused {
  border-color: var(--primary-main);
}

.RaCreate-main .MuiToolbar-root.RaToolbar-desktopToolbar, 
.RaEdit-main .MuiToolbar-root.RaToolbar-desktopToolbar {
  background: transparent;
  border-top: 1px solid var(--gray-200);
  padding-top: 24px;
  margin-top: 32px;
}
.MuiToolbar-root .RaToolbar-defaultToolbar .MuiButtonBase-root {
  min-width: 120px;
}

/* Video Player Styles */
.video-player-container {
  width: 100%;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: var(--gray-600);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--gray-200);
  border-top-color: var(--primary-main);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.video-content {
  width: 100%;
}

.video-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 2rem;
  margin: 0 auto;
  max-width: 100%;
}

.video-section {
  grid-column: span 6;
}

.subtitles-section {
  grid-column: span 6;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

@media (max-width: 1024px) {
  .video-layout {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .video-section,
  .subtitles-section {
    grid-column: 1 / -1;
  }
}

.video-wrapper {
  width: 100%;
  aspect-ratio: 16/9;
}
.video-wrapper .video-js{
  width: 100%;
  aspect-ratio: 16 / 9;
  height: 390px;
}

.subtitles-selector {
  background-color: var(--bg-paper);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: var(--shadow-sm);
}

.subtitles-selector h3 {
  color: var(--gray-900);
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.subtitle-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.subtitle-button {
  background-color: var(--gray-50);
  color: var(--gray-700);
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.subtitle-button:hover {
  background-color: var(--gray-100);
  border-color: var(--gray-300);
}

.subtitle-button.active {
  background-color: var(--primary-alpha-10);
  border-color: var(--primary-main);
  color: var(--primary-main);
}

.subtitle-editor-wrapper {
  max-height: 650px;
  overflow-y: auto;
  border-radius: 8px;
  margin-bottom: 1rem;
  padding: 0;
}
.subtitle-editor-wrapper .ant-input ,.subtitle-editor-wrapper .play, .subtitle-editor-wrapper .dotqnP, .subtitle-editor-wrapper .separator{
  color: #000000 !important;
}
.subtitle-editor-wrapper .play {
  margin-inline: 5px;
}

.subtitle-editor-wrapper .sc-FEMpB{
  color: #000000 !important;
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.subtitle-editor-wrapper .sc-FEMpB.kNCfpj{
  color: #fff !important;
  background: var(--primary-main);
}
.subtitle-editor-wrapper .sc-FEMpB:hover{
  border: 1px solid var(--gray-300);
}
.subtitle-editor-wrapper .sc-FEMpB .time{
  border: 0 !important;
}
.subtitle-editor-wrapper .sc-FEMpB textarea{
  border: 0;
  box-shadow: none;
  outline: none;
  resize: none;
}

.subtitle-editor-wrapper::-webkit-scrollbar {
  width: 8px;
}

.subtitle-editor-wrapper::-webkit-scrollbar-track {
  background: var(--gray-100);
  border-radius: 4px;
}

.subtitle-editor-wrapper::-webkit-scrollbar-thumb {
  background: var(--gray-300);
  border-radius: 4px;
}

.subtitle-editor-wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--gray-400);
}

/* Fix for creating a scrollable container for subtitles */
.subtitle-editor-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Make sure pagination buttons are always visible at the bottom */
.subtitle-pagination-container {
  position: sticky !important;
  bottom: 0 !important;
  padding: 10px 0 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  margin-top: auto !important;
  z-index: 100 !important;
}

/* Force subtitle rows to be in a scrollable container */
.subtitle-rows-container {
  overflow-y: auto !important;
  max-height: 550px !important;
  padding-bottom: 16px !important;
}

.save-button, .download-button, .import-button {
  background-color: var(--primary-main);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  margin-top: 2rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  box-shadow: var(--shadow-xs);
  margin-inline: 5px;
}
.download-button {
  background-color: black;
}

.import-button {
  background-color: deepskyblue;
}

.save-button:hover {
  background-color: var(--primary-dark);
}

.edit-page .css-16yq2fb-MuiToolbar-root-RaTopToolbar-root, .show-page .css-16yq2fb-MuiToolbar-root-RaTopToolbar-root{
  margin-top: -68px;
  width: 50%;
  float: right;
}
.edit-page .MuiToolbar-root .MuiButton-text, .show-page .MuiToolbar-root .MuiButton-text{
  font-size: 1rem;
  font-weight: 500;
}
.show-page .ra-field{
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  margin: 1rem;
  font-size: 1rem;
}
.show-page .ra-field .MuiTypography-root.RaLabeled-label{
  font-size: 1rem;
  font-weight: 500;
  background-color: var(--gray-50);
  padding: 1rem;
  border-radius: 8px 8px 0 0;
}
.show-page .ra-field .MuiTypography-root{
  font-size: 1rem;
  font-weight: 500;
  padding: 1rem 1rem 1.5rem;
  display: block;
}

.icon-button {
  background: none;
  border: none;
  color: rgba(112, 112, 112, 0.45);
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  transition: color 0.3s ease;
}

.icon-button:hover {
  color: rgb(0, 0, 0);
}

.separator {
  font-size: 16px;
}

.audio-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.audio-section, .subtitles-section {
  flex: 1 1;
  min-width: 300px;
}

.audio-wrapper {
  display: flex;
  align-items: flex-end;
  background-color: #383838;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  aspect-ratio: 16 / 9;
  height: auto;
  max-height: 390px;
  min-height: 200px;
  width: 100%;
}

.audio-element {
  width: 100%;
  min-width: 250px;
}

@media (max-width: 1024px) {
  .audio-layout {
    flex-direction: column;
  }

  .audio-section, .subtitles-section {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .audio-wrapper {
    padding: 15px;
    min-height: 150px;
  }

  .subtitle-buttons {
    flex-direction: column;
    align-items: flex-start;
  }

  .subtitle-button {
    width: 100%;
    margin-bottom: 8px;
  }

  .save-button, .download-button {
    width: 100%;
    margin: 10px 0;
  }
}

.file-input {
  display: block !important;
}

.file-input-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.file-input-container span {
  font-size: 17px;
}

.time-container {
  display: flex;
  align-items: end;
  width: 100%;
}

.video-title, .audio-title {
  margin-bottom: 20px;
}

.audio-title {
  margin-left: 10px;
}

.not-found-message {
  color: var(--gray-500);
  font-weight: bold;
  font-size: 1.5rem;
  margin-top: 2rem;
}

/* Make sure pagination buttons are visible */
.pagination {
  display: flex !important;
  justify-content: center !important;
  list-style-type: none !important;
  padding: 0 !important;
  margin: 16px 0 !important;
}

.pagination li {
  margin: 0 3px !important;
  display: inline-block !important;
}

.pagination li a {
  padding: 6px 10px !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  color: var(--gray-800) !important;
  background-color: var(--gray-200) !important;
  transition: all 0.3s ease !important;
  display: inline-block !important;
  text-align: center !important;
  min-width: 28px !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
  border: 1px solid var(--gray-300) !important;
  box-shadow: var(--shadow-xs) !important;
}

.pagination li a:hover {
  background-color: var(--gray-300) !important;
  color: var(--gray-900) !important;
}

.pagination li.active a {
  background-color: var(--primary-main) !important;
  color: white !important;
  border-color: var(--primary-main) !important;
}

.pagination li.disabled a {
  color: var(--gray-400) !important;
  pointer-events: none !important;
  background-color: var(--gray-100) !important;
  border-color: var(--gray-200) !important;
}

/* Fix for SubtitleEditor-2.js pagination */
.subtitle-editor-container .PaginationContainer {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  display: block !important;
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,0CAA0C;;EAE1C,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;;EAEzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,wBAAwB;;EAExB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;;EAE3B,YAAY;EACZ,+CAA+C;EAC/C,8CAA8C;EAC9C,kFAAkF;EAClF,kFAAkF;AACpF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sDAAsD;;;AAGtD;EACE,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE;MACI,gBAAgB;MAChB,SAAS;MACT,UAAU;EACd;AACF;AACA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,yDAAyD;EACzD,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,uBAAuB;EACvB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,yDAAyD;EACzD,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,wDAAwD;AACxD;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,wBAAwB;EACxB,kCAAkC;EAClC,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,iCAAiC;EACjC,4CAA4C;EAC5C,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;EAC5B,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":[":root {\n  /* Colors */\n  --primary-main: #02d38d;\n  --primary-light: #33dc9f;\n  --primary-dark: #019362;\n  --primary-alpha-10: rgba(2, 211, 141, 0.1);\n  \n  --secondary-main: #000000;\n  --secondary-light: #333333;\n  --secondary-dark: #000000;\n  \n  /* Neutral colors */\n  --gray-25: #fcfcfd;\n  --gray-50: #f9fafb;\n  --gray-100: #f2f4f7;\n  --gray-200: #eaecf0;\n  --gray-300: #d0d5dd;\n  --gray-400: #98a2b3;\n  --gray-500: #667085;\n  --gray-600: #475467;\n  --gray-700: #344054;\n  --gray-800: #1d2939;\n  --gray-900: #101828;\n  \n  /* Status colors */\n  --error: #f04438;\n  --error-light: #fee4e2;\n  --success: var(--primary-main);\n  --success-light: var(--primary-alpha-10);\n  --warning: #f79009;\n  --warning-light: #fef0c7;\n  \n  /* Backgrounds */\n  --bg-white: #ffffff;\n  --bg-default: var(--gray-100);\n  --bg-paper: var(--bg-white);\n  --bg-subtle: var(--gray-50);\n  \n  /* Shadows */\n  --shadow-xs: 0px 1px 2px rgba(16, 24, 40, 0.05);\n  --shadow-sm: 0px 1px 3px rgba(16, 24, 40, 0.1);\n  --shadow-md: 0px 5px 22px rgba(0, 0, 0, 0.04), 0px 0px 0px 1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0px 8px 28px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.06);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--gray-100);\n  color: var(--gray-900);\n  line-height: 1.5;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Custom scrollbar styles */\nhtml body ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\nhtml body ::-webkit-scrollbar-track {\n  background: var(--gray-100);\n}\n\nhtml body ::-webkit-scrollbar-thumb {\n  background: var(--gray-300);\n  border-radius: 4px;\n}\n\nhtml body ::-webkit-scrollbar-thumb:hover {\n  background: var(--gray-400);\n}\n\n/* Table styles with React Admin component hierarchy */\n\n\n.RaDatagrid-table .RaDatagrid-row .RaDatagrid-headerCell {\n  background-color: var(--gray-50);\n  color: var(--gray-500);\n  white-space: nowrap;\n  line-height: 2;\n}\n.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall {\n  color: var(--gray-800);\n  width: 30px;\n  overflow: hidden;\n  display: inline-block;\n  height: 30px;\n  text-align: right;\n  min-width: 30px;\n  padding: 0;\n}\n\n.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall:hover {\n  background-color: var(--gray-100);\n}\n.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall .MuiButton-icon {\n  margin: 0;\n}\n.RaDatagrid-table .RaDatagrid-row .MuiTableCell-root .MuiButton-sizeSmall .MuiButton-icon svg {\n  font-size: 22px;\n}\n@media (min-width: 600px) {\n  .RaList-actions .css-18hcsan-RaFilterForm-root {\n      min-height: auto;\n      margin: 0;\n      padding: 0;\n  }\n}\n.css-1ycqwd-RaList-root .RaList-main {\n  background-color: var(--bg-paper);\n  color: var(--gray-900);\n  background-image: none;\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n  border-radius: 20px;\n  box-shadow: var(--shadow-md);\n}\n.MuiBox-root.css-106q77t{\n  background: var(--bg-white);\n}\n.RaCreate-main .MuiPaper-root.MuiPaper-elevation, \n.RaEdit-main .MuiPaper-root.MuiPaper-elevation {\n  padding: 50px 32px 32px;\n}\n.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiStack-root, \n.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiStack-root {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 32px 40px;\n  margin-bottom: 32px;\n  padding: 0;\n}\n.css-17418m4-RaEdit-root .RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiStack-root{\n  display: block;\n}\n.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root, \n.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root {\n  width: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputLabel-root, \n.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputLabel-root {\n  color: var(--gray-700);\n  transform: none;\n  top: -30px;\n  font-weight: 500;\n}\n.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input, \n.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input {\n  height: auto;\n  padding: 12px 20px;\n  font-size: 0.875rem;\n  color: var(--gray-900);\n  line-height: 1.5;\n}\n\n.RaCreate-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root.Mui-focused, \n.RaEdit-main .MuiPaper-root.MuiPaper-elevation .MuiFormControl-root .MuiInputBase-root.Mui-focused {\n  border-color: var(--primary-main);\n}\n\n.RaCreate-main .MuiToolbar-root.RaToolbar-desktopToolbar, \n.RaEdit-main .MuiToolbar-root.RaToolbar-desktopToolbar {\n  background: transparent;\n  border-top: 1px solid var(--gray-200);\n  padding-top: 24px;\n  margin-top: 32px;\n}\n.MuiToolbar-root .RaToolbar-defaultToolbar .MuiButtonBase-root {\n  min-width: 120px;\n}\n\n/* Video Player Styles */\n.video-player-container {\n  width: 100%;\n}\n\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  color: var(--gray-600);\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--gray-200);\n  border-top-color: var(--primary-main);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.video-content {\n  width: 100%;\n}\n\n.video-layout {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 2rem;\n  margin: 0 auto;\n  max-width: 100%;\n}\n\n.video-section {\n  grid-column: span 6;\n}\n\n.subtitles-section {\n  grid-column: span 6;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n@media (max-width: 1024px) {\n  .video-layout {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .video-section,\n  .subtitles-section {\n    grid-column: 1 / -1;\n  }\n}\n\n.video-wrapper {\n  width: 100%;\n  aspect-ratio: 16/9;\n}\n.video-wrapper .video-js{\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  height: 390px;\n}\n\n.subtitles-selector {\n  background-color: var(--bg-paper);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.subtitles-selector h3 {\n  color: var(--gray-900);\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n}\n\n.subtitle-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.subtitle-button {\n  background-color: var(--gray-50);\n  color: var(--gray-700);\n  border: 1px solid var(--gray-200);\n  border-radius: 8px;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.subtitle-button:hover {\n  background-color: var(--gray-100);\n  border-color: var(--gray-300);\n}\n\n.subtitle-button.active {\n  background-color: var(--primary-alpha-10);\n  border-color: var(--primary-main);\n  color: var(--primary-main);\n}\n\n.subtitle-editor-wrapper {\n  max-height: 650px;\n  overflow-y: auto;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  padding: 0;\n}\n.subtitle-editor-wrapper .ant-input ,.subtitle-editor-wrapper .play, .subtitle-editor-wrapper .dotqnP, .subtitle-editor-wrapper .separator{\n  color: #000000 !important;\n}\n.subtitle-editor-wrapper .play {\n  margin-inline: 5px;\n}\n\n.subtitle-editor-wrapper .sc-FEMpB{\n  color: #000000 !important;\n  border: 1px solid var(--gray-200);\n  border-radius: 8px;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.subtitle-editor-wrapper .sc-FEMpB.kNCfpj{\n  color: #fff !important;\n  background: var(--primary-main);\n}\n.subtitle-editor-wrapper .sc-FEMpB:hover{\n  border: 1px solid var(--gray-300);\n}\n.subtitle-editor-wrapper .sc-FEMpB .time{\n  border: 0 !important;\n}\n.subtitle-editor-wrapper .sc-FEMpB textarea{\n  border: 0;\n  box-shadow: none;\n  outline: none;\n  resize: none;\n}\n\n.subtitle-editor-wrapper::-webkit-scrollbar {\n  width: 8px;\n}\n\n.subtitle-editor-wrapper::-webkit-scrollbar-track {\n  background: var(--gray-100);\n  border-radius: 4px;\n}\n\n.subtitle-editor-wrapper::-webkit-scrollbar-thumb {\n  background: var(--gray-300);\n  border-radius: 4px;\n}\n\n.subtitle-editor-wrapper::-webkit-scrollbar-thumb:hover {\n  background: var(--gray-400);\n}\n\n/* Fix for creating a scrollable container for subtitles */\n.subtitle-editor-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Make sure pagination buttons are always visible at the bottom */\n.subtitle-pagination-container {\n  position: sticky !important;\n  bottom: 0 !important;\n  padding: 10px 0 !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;\n  margin-top: auto !important;\n  z-index: 100 !important;\n}\n\n/* Force subtitle rows to be in a scrollable container */\n.subtitle-rows-container {\n  overflow-y: auto !important;\n  max-height: 550px !important;\n  padding-bottom: 16px !important;\n}\n\n.save-button, .download-button, .import-button {\n  background-color: var(--primary-main);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  margin-top: 2rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  box-shadow: var(--shadow-xs);\n  margin-inline: 5px;\n}\n.download-button {\n  background-color: black;\n}\n\n.import-button {\n  background-color: deepskyblue;\n}\n\n.save-button:hover {\n  background-color: var(--primary-dark);\n}\n\n.edit-page .css-16yq2fb-MuiToolbar-root-RaTopToolbar-root, .show-page .css-16yq2fb-MuiToolbar-root-RaTopToolbar-root{\n  margin-top: -68px;\n  width: 50%;\n  float: right;\n}\n.edit-page .MuiToolbar-root .MuiButton-text, .show-page .MuiToolbar-root .MuiButton-text{\n  font-size: 1rem;\n  font-weight: 500;\n}\n.show-page .ra-field{\n  border: 1px solid var(--gray-200);\n  border-radius: 8px;\n  margin: 1rem;\n  font-size: 1rem;\n}\n.show-page .ra-field .MuiTypography-root.RaLabeled-label{\n  font-size: 1rem;\n  font-weight: 500;\n  background-color: var(--gray-50);\n  padding: 1rem;\n  border-radius: 8px 8px 0 0;\n}\n.show-page .ra-field .MuiTypography-root{\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 1rem 1rem 1.5rem;\n  display: block;\n}\n\n.icon-button {\n  background: none;\n  border: none;\n  color: rgba(112, 112, 112, 0.45);\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n  transition: color 0.3s ease;\n}\n\n.icon-button:hover {\n  color: rgb(0, 0, 0);\n}\n\n.separator {\n  font-size: 16px;\n}\n\n.audio-layout {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.audio-section, .subtitles-section {\n  flex: 1;\n  min-width: 300px;\n}\n\n.audio-wrapper {\n  display: flex;\n  align-items: flex-end;\n  background-color: #383838;\n  border-radius: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  aspect-ratio: 16 / 9;\n  height: auto;\n  max-height: 390px;\n  min-height: 200px;\n  width: 100%;\n}\n\n.audio-element {\n  width: 100%;\n  min-width: 250px;\n}\n\n@media (max-width: 1024px) {\n  .audio-layout {\n    flex-direction: column;\n  }\n\n  .audio-section, .subtitles-section {\n    width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .audio-wrapper {\n    padding: 15px;\n    min-height: 150px;\n  }\n\n  .subtitle-buttons {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .subtitle-button {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n\n  .save-button, .download-button {\n    width: 100%;\n    margin: 10px 0;\n  }\n}\n\n.file-input {\n  display: block !important;\n}\n\n.file-input-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-input-container span {\n  font-size: 17px;\n}\n\n.time-container {\n  display: flex;\n  align-items: end;\n  width: 100%;\n}\n\n.video-title, .audio-title {\n  margin-bottom: 20px;\n}\n\n.audio-title {\n  margin-left: 10px;\n}\n\n.not-found-message {\n  color: var(--gray-500);\n  font-weight: bold;\n  font-size: 1.5rem;\n  margin-top: 2rem;\n}\n\n/* Make sure pagination buttons are visible */\n.pagination {\n  display: flex !important;\n  justify-content: center !important;\n  list-style-type: none !important;\n  padding: 0 !important;\n  margin: 16px 0 !important;\n}\n\n.pagination li {\n  margin: 0 3px !important;\n  display: inline-block !important;\n}\n\n.pagination li a {\n  padding: 6px 10px !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  color: var(--gray-800) !important;\n  background-color: var(--gray-200) !important;\n  transition: all 0.3s ease !important;\n  display: inline-block !important;\n  text-align: center !important;\n  min-width: 28px !important;\n  text-decoration: none !important;\n  font-weight: 500 !important;\n  font-size: 0.9rem !important;\n  border: 1px solid var(--gray-300) !important;\n  box-shadow: var(--shadow-xs) !important;\n}\n\n.pagination li a:hover {\n  background-color: var(--gray-300) !important;\n  color: var(--gray-900) !important;\n}\n\n.pagination li.active a {\n  background-color: var(--primary-main) !important;\n  color: white !important;\n  border-color: var(--primary-main) !important;\n}\n\n.pagination li.disabled a {\n  color: var(--gray-400) !important;\n  pointer-events: none !important;\n  background-color: var(--gray-100) !important;\n  border-color: var(--gray-200) !important;\n}\n\n/* Fix for SubtitleEditor-2.js pagination */\n.subtitle-editor-container .PaginationContainer {\n  margin-top: 20px !important;\n  margin-bottom: 20px !important;\n  display: block !important;\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
